import { Controller } from "@hotwired/stimulus"

// In some cases the default toggle for popovers in Bootstrap does not work, you can use this controller to trigger
// the popover instead.
export default class extends Controller {
  connect() {
    App.popover(this.element)
  }
}
